import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/obituary-fe/app/components/novosti/NovostiContent.js");
